import { ArrowRight, CheckCircle2 } from "lucide-react";
import { PRODUCTS } from "@/lib/products";

export default function Products({ onQuoteClick }) {
  return (
    <section
      id="products"
      data-testid="products-section"
      className="py-16 md:py-24 bg-[#f8fafc]"
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="max-w-2xl">
          <span className="eyebrow">Our Products</span>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            One platform.<br /> Every insurance you need.
          </h2>
          <p className="font-hindi mt-3 text-lg text-[#1e3a8a] font-semibold">
            हर ज़रूरत के लिए सही बीमा, सही सलाह
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PRODUCTS.map((p, i) => {
            const Icon = p.icon;
            return (
              <article
                key={p.slug}
                data-testid={`product-card-${p.slug}`}
                className="group bg-white border border-slate-200 rounded-2xl overflow-hidden hover:shadow-2xl hover:border-[#f5b942] hover:-translate-y-1 transition-all duration-300 flex flex-col"
                style={{ animationDelay: `${i * 60}ms` }}
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title_en}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                  <div className="absolute top-4 left-4 w-11 h-11 rounded-xl bg-white shadow flex items-center justify-center">
                    <Icon className={`w-5 h-5 ${p.accent}`} />
                  </div>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="font-display text-xl font-bold text-slate-900">
                    {p.title_en}
                  </h3>
                  <p className="font-hindi text-sm text-[#1e3a8a] font-semibold mt-0.5">
                    {p.title_hi}
                  </p>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                    {p.desc}
                  </p>
                  <ul className="mt-4 space-y-2">
                    {p.bullets.map((b) => (
                      <li key={b} className="flex items-start gap-2 text-sm text-slate-700">
                        <CheckCircle2 className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0" />
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                  <button
                    data-testid={`product-quote-${p.slug}`}
                    onClick={() => onQuoteClick(p.slug)}
                    className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-[#1e3a8a] hover:text-[#172554] group/btn"
                  >
                    Get Quote
                    <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
